import { computed } from 'vue'
import { useSessionStore } from '@/stores/session'

/**
 * Composable for checking boolean plan entitlements (e.g.
 * `flag_lifecycle_management`, `audit_log_access`, `advanced_reporting`,
 * `management_api_access`), matching backend Account::hasPlanFeature().
 *
 * Usage:
 *   const { hasPlanFeature } = usePlan()
 *   if (hasPlanFeature('audit_log_access')) { ... }
 */
export function usePlan() {
    const sessionStore = useSessionStore()

    // A Map (not a plain object) so the dynamic key lookup below doesn't trip
    // eslint-plugin-security's object-injection check, matching the convention
    // used elsewhere for dynamic lookups (e.g. the reports screens' label maps).
    const planAttributes = computed(() => {
        const attributes =
            sessionStore.data?.account?.data?.plan?.data?.attributes ?? {}
        return new Map(Object.entries(attributes))
    })

    /**
     * Missing keys default to true (enabled), matching the backend default -
     * plans that predate a given entitlement aren't inadvertently locked out.
     */
    function hasPlanFeature(key) {
        const value = planAttributes.value.get(key)
        return value === undefined || value === null ? true : Boolean(value)
    }

    return { hasPlanFeature }
}
